import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/confluencePremiumPopupEditionAwarenessQuery.graphql';

export type EntryPointParams = {
	isConfluence: boolean;
	hamsProductKey: string;
	cloudId: string;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-premium-popup-dialog" */ './dialog'
			),
		{
			moduleId: 'edition-awareness-premium-popup-dialog',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey, isConfluence }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			confluencePremiumPopupEditionAwarenessQuery: {
				parameters,
				variables: {
					isConfluence,
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
